<template>
  <LayoutTelas
    id="tela__fechamento"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">
    <BForm
      v-if="mostrarFiltroData()"
      @submit.prevent="filtrar"
      class="form__fechamento">
      <InputSugestaoFilial
        ref="inputFilial"
        label="Filial"
        name="inputFilial"
        class="input__filial"
        v-model="form.filial"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputBasico
        type="date"
        label="Data inicial"
        name="inputDataInicial"
        class="input__datainicial"
        v-model="form.dataInicial"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputBasico
        type="date"
        label="Data final"
        name="inputDataFinal"
        class="input__datafinal"
        v-model="form.dataFinal"
        v-validate="'required'"
        :errorsBag="errors" />

      <div class="botoes__container">
        <BButton
          type="submit"
          variant="primary">
          Filtrar
        </BButton>
      </div>
    </BForm>
    <BTable
      class="tabela__lancamentos"
      stacked
      striped
      small
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :fields="colunas"
      :items="listaFechamentos">
      <template
        v-if="mostrarFiltroData()"
        :slot="'totalpagar'"
        slot-scope="data">
        {{ data.value | currency }}
      </template>
    </BTable>

    <div v-if="totalizador"
      class="totais__container">
      <p>Total geral: {{ totalizador.totalGeral | currency }}</p>
      <p>Total em dinheiro: {{ totalizador.totalDinheiro | currency }}</p>
      <p>Total em cartão: {{ totalizador.totalCartao | currency }}</p>
      <p v-if="mostrarFiltroData()">Total barbeiros: {{ totalizador.totalBarbeiros | currency }}</p>
      <p v-if="mostrarFiltroData()">Total líquido: {{ totalizador.totalLiquido | currency }}</p>
    </div>

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      main-icon="add"
      :start-opened="true"
      @filtrar="filtrar"
      @gerarPdf="gerarPdf" />
  </LayoutTelas>
</template>

<script>
import fab from 'vue-fab'
import moment from 'moment'
import _ from 'lodash'

import { BForm, BTable, BButton } from 'bootstrap-vue/es/components'
import Cargos from '@/models/Cargos'
import InputBasico from '@/components/inputs/InputBasico.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'
import servicoService from '@/modules/administrativo/services/servicos.service'
import lancamentoService from '../../services/lancamento.service'
import * as msgs from '../../mensagens/fechamento.msg'
import GerarPdfFechamentoCaixa from '@/modules/pdfs/GerarPdfFechamentoCaixa'
import InputSugestaoFilial from '@/modules/administrativo/components/inputs/sugestao/InputSugestaoFilial.vue'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'filtrar',
      icon: 'sync',
      tooltip: 'Atualizar',
    },
    {
      name: 'gerarPdf',
      icon: 'print',
      tooltip: 'Gerar PDF',
    },
  ],
}

export default {
  name: 'Fechamento',
  mixins: [GeradorMensagens],
  components: {
    BForm,
    BTable,
    BButton,
    InputBasico,
    fab,
    InputSugestaoFilial,
  },
  mounted() {
    if (this.mostrarFiltroData()) {
      this.focarPrimeiroCampo()
    }
  },
  data() {
    return {
      floatButton: botaoFlutuante,
      sortBy: 'totalpagar',
      sortDesc: false,
      form: this.retornaValoresIniciaisForm(),
      isLoading: false,
      listaFechamentos: [],
      totalizador: null,
      colunas: [],
      wFilial: '',
    }
  },
  async beforeMount() {
    await this.montarColunas()
    if (!this.mostrarFiltroData()) {
      this.filtrar()
    }
  },
  methods: {
    limpaDados() {
      this.listaFechamentos = []
      this.totalizador = null
    },
    filtrar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let filial = ''
          if (this.mostrarFiltroData()) {
            filial = this.form.filial._id
            this.wFilial = this.form.filial.nome
          } else {
            filial = this.$store.getters['autenticacao/userObj'].usuario.filial._id
            this.wFilial = this.$store.getters['autenticacao/userObj'].usuario.filial.nome;
          }
          const filtro = {
            ...this.form,
            filial,
          }

          this._carregarDados(filtro)
        }
      })
    },
    mostrarLoading(mostrar = true) {
      this.isLoading = mostrar
    },
    focarPrimeiroCampo() {
      this.$refs.inputFilial.focar()
    },
    retornaValoresIniciaisForm() {
      return {
        filial: null,
        dataInicial: this.retornaDataAtual(),
        dataFinal: this.retornaDataAtual(),
      }
    },
    async montarColunas() {
      try {
        this.mostrarLoading()
        const servicos = await servicoService.retornaTodos()
        if (servicos.lista.length > 0) {
          const objMap = servicos.lista.map(servico => {
            const retorno = {
              key: servico._id,
              label: servico.descricao,
            }

            return retorno
          })

          this.colunas = [
            {
              key: 'funcionario',
              label: 'Barbeiro',
            },
          ]

          if (this.mostrarFiltroData()) {
            this.colunas.push({
              key: 'totalpagar',
              label: 'Total a pagar',
            })
          }

          this.colunas.push(...[
            {
              key: 'quantidadeAtendimentos',
              label: 'Qnt. atendimentos',
            },
            ...objMap,
            {
              key: 'produtos',
              label: 'Produtos',
            },
          ])
        }
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoading(false)
      }
    },
    async _carregarDados(filtro) {
      try {
        this.mostrarLoading()
        this.limpaDados()
        const retorno = await lancamentoService.listaFaturamentos(filtro)
        if (retorno) {
          this.montaListaFechamentos(retorno.itens)
          this.totalizador = this.retornaTotalizadores(retorno.totalizador)
        } else {
          this.$awn.warning(msgs.NAO_ENCONTRADO)
        }
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoading(false)
      }
    },
    retornaDataAtual() {
      return moment().format('YYYY-MM-DD')
    },
    mostrarFiltroData() {
      const cargo = this.$store.getters['autenticacao/userObj'].usuario
      if (cargo) {
        return cargo.role === Cargos.ADMINISTRADOR
      }

      return false
    },
    montaListaFechamentos(itens) {
      // console.log(itens)
      const objTotalizador = {
        totalProdutos: 0,
        quantidadeAtendimentos: 0,
        totalpagar: 0,
      }

      this.listaFechamentos = itens.map(item => {
        const { funcionario, servicos, produtos } = item

        let totalProdutos = null
        _.forIn(produtos, value => {
          totalProdutos += value
        })

        _.forIn(servicos, (value, key) => {
          if (!objTotalizador[key]) {
            objTotalizador[key] = 0
          }
          objTotalizador[key] += value
        })

        objTotalizador.totalProdutos += totalProdutos
        objTotalizador.quantidadeAtendimentos += item.quantidadeAtendimentos
        objTotalizador.totalpagar += item.valorTotal

        const objRetornar = {
          funcionario: funcionario.nome,
          ...servicos,
          produtos: totalProdutos,
          quantidadeAtendimentos: item.quantidadeAtendimentos,
          totalpagar: item.valorTotal,
        }

        return objRetornar
      })
      console.log(objTotalizador)
      this.listaFechamentos.push(objTotalizador)
    },
    retornaTotalizadores(totalizador) {
      const cartao = totalizador.find(item => item._id === 'cartao')
      const dinheiro = totalizador.find(item => item._id === 'dinheiro')
      return {
        totalGeral: _.sumBy(totalizador, item => item.total),
        totalDinheiro: dinheiro ? dinheiro.total : 0,
        totalCartao: cartao ? cartao.total : 0,
        totalBarbeiros: _.sumBy(totalizador, item => item.totalBarbeiro),
        totalLiquido: _.sumBy(totalizador, item => item.totalLiquido),
      }
    },
    gerarPdf() {
      if (this.listaFechamentos.length > 0) {
        const geradorPdf = new GerarPdfFechamentoCaixa(this)
        const usuarioStore = this.$store.getters['autenticacao/userObj'].usuario
        const objImprimir = {
          itens: this.listaFechamentos,
          totalizador: this.totalizador,
          usuario: usuarioStore,
          filial: this.wFilial,
          periodo: {
            ...this.form,
          },
        }

        geradorPdf.gerarPdf(objImprimir, this.colunas)
      } else {
        this.$awn.warning(msgs.NAO_HA_DADOS_PARA_IMPRIMIR)
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

#tela__fechamento {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.form__fechamento {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $medium-size) {
    width: 100%;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 0.8em;
  }
}

.input {
  &__filial {
    @media (min-width: $medium-size) {
      grid-column: 1 / 3;
    }
  }

  &__datainicial {
    @media (min-width: $medium-size) {
      grid-column: 3 / 4;
    }
  }

  &__datafinal {
    @media (min-width: $medium-size) {
      grid-column: 4 / 5;
    }
  }
}

.botoes__container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (min-width: $medium-size) {
    margin-top: .9rem;
    grid-column: 5 / -1;
    justify-content: flex-start;
  }
}

.totais__container {
  margin-top: 1rem;
  padding: .4rem 0;
  border-top: 1px solid $cor-fundo-escura;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;

  & > p {
    margin: 0;
  }
}

</style>
